import { useArrowNavigationGroup, useFocusVisible, useMergedRefs, } from "@fluentui/react-components";
import { observer } from "owa-mobx-react";
import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";
import React from "react";
import { LazyStatusBarReminders, LazyStatusBarZoom } from "../lazyStatusBarItems";
import { statusBar } from "./StatusBar.scss";

type StatusBarProps = {
    targetRef?: React.Ref<HTMLDivElement>;
};

const StatusBar: React.FunctionComponent<StatusBarProps> = observer(function StatusBar({ targetRef, }) {
    // Show the status bar for everyone on the general flight, or only with Win32 styling on its separate flight.
    if (!isGlobalFeatureEnabled("mon-status-bar") &&
        (!isWin32StylingEnabled() || !isGlobalFeatureEnabled("mon-win32-styling-status-bar"))) {
        return null;
    }
    
    return <StatusBarContent targetRef={targetRef}/>;
}, "StatusBar");

const StatusBarContent: React.FunctionComponent<StatusBarProps> = observer(function StatusBarContent({ targetRef }) {
    // The status bar is outside #mainApp's focus-visible scope, so it needs its own.
    const focusVisibleRef = useFocusVisible<HTMLDivElement>();
    // Keep the portal target ref and Fluent's focus tracking on the same element.
    const rootRef = useMergedRefs(targetRef, focusVisibleRef);
    // Let Left/Right wrap between controls while preserving Tab/Shift+Tab navigation.
    const navigationAttributes = useArrowNavigationGroup({
        axis: "horizontal",
        circular: true,
        tabbable: true,
    });
    
    return (<div className={statusBar} ref={rootRef} data-app-section="StatusBar" {...navigationAttributes}>
                <LazyStatusBarReminders />
                <LazyStatusBarZoom />
            </div>);
}, "StatusBarContent");

export default StatusBar;
